<template>
  <section class="start-selling">
    <div class="osk-wrapper">
      <h2 class="section-title start-selling__title">
        {{ $t('components.home.old.startSelling.title') }}
      </h2>

      <div class="start-selling__content">
        <p class="start-selling__text">
          {{ $t('components.home.old.startSelling.text') }}
        </p>

        <div class="start-selling__content-links">
          <component
            :is="component"
            class="start-selling__link"
            :to="isAuth ? '/publication' : undefined"
            @click.prevent="handleClick"
          >
            {{ $t('components.home.old.startSelling.saleProduct') }}
          </component>

          <div class="start-selling__text-link">
            <a href="/info/seller">{{ $t('components.home.old.startSelling.howItWorks') }}</a>
          </div>
        </div>
      </div>

      <div class="start-selling__image-block">
        <picture>
          <source
            srcset="//oskelly.ru/images/icons/start_selling_img.webp"
            type="image/webp"
          >
          <source
            srcset="//static.oskelly.ru/images/icons/start_selling_img.jpg"
            type="image/jpeg"
          >
          <img
            class="start-selling__image"
            src="//oskelly.ru/images/icons/start_selling_img.webp"
            :alt="$t('components.home.old.startSelling.startSale')"
          >
        </picture>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const { isAuth, openAuthDialog } = useAccountStore();

const component = computed(() => {
  if (isAuth.value) return defineNuxtLink({});
  return 'span';
});

function handleClick() {
  if (!isAuth.value) {
    openAuthDialog({
      to: () => '/publication',
      chapter: 'sale_request',
    });
    return;
  }

  navigateTo('/publication');
}
</script>

<style scoped lang="scss">
.start-selling {
  padding: 55px 0 30px;
  background: #FAFAFA;

  @media screen and (min-width: 1024px) {
    padding: 60px 0 72px;
  }

  .osk-wrapper {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1024px) {
      display: table;
    }
  }

  &__title {
    margin-bottom: 34px;
    text-align: left;
    order: 1;

    @media screen and (min-width: 767px) {
      margin-bottom: 26px;
    }

    @media screen and (min-width: 1024px) {
      padding: 16px 16px 0 0;
    }
  }

  &__content {
    order: 3;

    @media screen and (min-width: 1024px) {
      padding-right: 16px;
      max-width: 560px;
    }
  }

  &__text {
    font-size: 14px;
    line-height: 23px;
    margin-bottom: 17px;

    @media screen and (min-width: 1024px) {
      font-size: 16px;
      line-height: 27px;
      margin-bottom: 34px;
    }
  }

  &__link {
    display: block;
    cursor: pointer;
    height: 46px;
    color: #fff;
    text-align: center;
    line-height: 46px;
    background: #202020;
    transition: .3s;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 29px;

    &:hover {
      opacity: .5;
    }

    @media screen and (min-width: 767px) {
      display: inline-block;
      width: 294px;
      margin-bottom: 0;
    }
  }

  &__content-links {
    text-align: center;

    @media screen and (min-width: 1024px) {
      text-align: left;
      display: flex;
      align-items: center;
    }
  }

  &__text-link {
    text-decoration: underline;
    font-size: 14px;
    line-height: 17px;
    color: #333;

    @media screen and (min-width: 1024px) {
      margin-left: 53px;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &__image-block {
    margin-bottom: 12px;
    order: 2;

    @media screen and (min-width: 1024px) {
      display: table-cell;
      vertical-align: top;
      width: 50%;
    }
  }

  &__image {
    width: 100%;
  }
}
</style>
